import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

export const CACHE_KEY = 'X-No-Cache';

@Injectable()
export class CacheHeaderInterceptor implements HttpInterceptor {
   intercept(req: HttpRequest<any>, next: HttpHandler) {

     const noCache = req.headers.get(CACHE_KEY);

     if (!noCache) {
      return next.handle(req);
    }

     const noCacheReq = req.clone({
      headers: req.headers.delete(CACHE_KEY)
    }).clone({
      headers: req.headers.set('Cache-Control', 'private, no-cache, no-store, must-revalidate')
        .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
        .set('If-Modified-Since', '0')
    });

     return next.handle(noCacheReq);
  }
}
